import { useState } from 'react';

import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import ParityNotificationsService from '~/services/ParityNotificationsService';

import type { TriggerEmailResult } from '~/types/services/parityNotifications';

export function useSendNotificationEmail() {
  const { enqueueSnackbar } = useSnackbar();
  const [sendingEmailId, setSendingEmailId] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: (id: string) => ParityNotificationsService.triggerNotificationEmail(id),
    onMutate: (id) => setSendingEmailId(id),
    onSuccess: (result: TriggerEmailResult) => {
      setSendingEmailId(null);
      const detail = result.errors.length > 0 ? ` (${result.errors.join(', ')})` : '';
      enqueueSnackbar(`Email sent — ${result.sent}/${result.totalUsers} users succeeded${detail}`, {
        variant: result.failed > 0 ? 'warning' : 'success',
      });
    },
    onError: (error: Error) => {
      setSendingEmailId(null);
      enqueueSnackbar(`Send email failed: ${error.message}`, { variant: 'error' });
    },
  });

  return { sendEmailMutation: mutation, sendingEmailId };
}
